import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchBasketballHeatmapProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchBasketballHeatmap: FC<SrWidgetMatchBasketballHeatmapProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true, disableMatchHeader: true };
    return <SrWidget widgetName="match.basketball.heatmap" widgetProps={widgetProps} {...props} />;
};
